export default {
  message: {
    default: 'Messages',
    show: {
      show: 'Voir les messages',
      page_title: "Message du ",
    },
    send: 'Envoyer un message',
    subject: 'Sujet du message',
    alert: {
      success: 'Votre message a bien été envoyé',
      failure: 'Une erreur est survenue. Le message n\'a pas pu être envoyé'
    },
    empty: 'Aucun message',
    newMessages: {
      new: 'nouveau | nouveaux',
      message: 'message | messages',
      newMessage: 'nouveau message'
    },
    cancelMessage: {
      title: "Annulation réservation"
    },
    text: {
      default: "Pour toute demande annexe liée ou non à une réservation, vous pouvez utiliser cette messagerie interne. Elle est directement reliée à votre agent de réservation qui répondra à votre demande dans les plus brefs délais.<br>Si cela concerne une réservation, rappelez le numéro de réservation pour permettre un traitement plus rapide de votre demande.",
      cancel: "Le délai pour annuler votre réservation sans frais a été dépassé. Vous pouvez nous adresser vos commentaires ci-après. Votre agent de réservation répondra à votre demande dans les plus brefs délais."
    },
    list: {
      page_title: "Liste des messages",
      date: "Date"
    },
    create: {
      page_title: "Nouveau message",
      placeholder: "Saisissez ici votre message"
    },
    fields: {
      subject: "Sujet",
      content: "Contenu",
      file: "Pièce-jointe"
    },
    sentAtBy: "envoyé le {date} par {sender}"
  }
}
